/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import "./filtering.css";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../services/AxiosInstance";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        type="search"
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const BrokerPDF = () => {
  const keys = [
    "id",
    "borrower.name",
    "borrower.email",
    "borrower.role.name",
    "uniqueId",
  ];
  const [data, setData] = useState([]);
  const [id, setId] = useState("");
  const [editshow, setEditShow] = useState(false);
  const onEditShow = () => setEditShow(true);
  const onEditHide = () => setEditShow(false);
  const [loader, setLoader] = useState(false);
  const [brokerpdf, setBrokerPdf] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [fieldValues, setFieldValues] = useState({
    comments: "",
    type: 0,
  });
  const [pdfBlobURL, setPdfBlobURL] = useState(null);
  const driverData = useSelector((state) => state.driver.data);
  console.log(driverData,"<====driverData")
  const ref = useRef();
  const viewPdf = () => ref.current.click();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setPdf(file);
    if (file) {
      const blobURL = URL.createObjectURL(file);
      setPdfBlobURL(blobURL);
    }
  };
  const COLUMNS = [
    ...keys.map((key) => ({
      Header:
        key.replace(/borrower./g, "Broker ") === "Broker role.name"
          ? "Role"
          : key.replace(/borrower./g, "Broker "),
      Footer:
        key.replace(/borrower./g, "Broker ") === "Broker role.name"
          ? "Role"
          : key.replace(/borrower./g, "Broker "),
      accessor: key,
      Filter: ColumnFilter,
    })),

    {
      Header: "Profile Picture",
      Footer: "Profile Picture",
      accessor: "borrower.image",
      Cell: ({ value }) => {
        return (
          <>
            <img
              src={value}
              alt=""
              width={60}
              style={{ borderRadius: "50%" }}
              height={60}
            />
          </>
        );
      },
    },

    {
      Header: "Action",
      Footer: "Action",
      Cell: ({ row }) => {
        const Deletepdf = (id) => {
          setLoader(true);
          try {
            axiosInstance
              .delete(`pdf/${id}`)
              .then((response) => {
                if (response.data.status === true) {
                  getBrokerPdf();
                  toast.success(response.data.message);
                  setLoader(false);
                } else {
                  toast.error("SomeThing went Wrong");
                  setLoader(false);
                }
              })
              .catch((errors) => {
                toast.error("SomeThing went Wrong");
                setLoader(false);
              });
          } catch (error) {
            toast.error(error);
          }
        };
        return (
          <>
            <div className="d-flex justify-content-evenly">
              <button
                onClick={() => {
                  setId(row.original.id);
                  getBrokerpdfid(row.original.id);
                }}
                title="View Pdf"
                className={`btn btn-outline-success btn-sm rounded`}
              >
                <i className="fa fa-file" />
              </button>
              <button
                onClick={() => {
                  Deletepdf(row.original.id);
                }}
                title="Delete"
                className={`btn btn-outline-danger btn-sm rounded`}
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const [columns] = useState(COLUMNS);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter, pageIndex } = state;

  const getBrokerPdf = () => {
    setLoader(true);
    axiosInstance
      .get("pdf")
      .then(function (response) {
        console.log(response, "Getting Compaines");
        if (response?.data.status === true) {
          setData(response?.data.data);
          toast.success(response.data.message);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  const getBrokerpdfid = (id) => {
    setLoader(true);
    axiosInstance
      .get(`pdf/${id}`)
      .then(function (response) {
        if (response?.data.status === true) {
          setBrokerPdf(response?.data.pdf);
          onEditShow();
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  const addDriverpdf = () => {
    setLoader(true);
    var formdata = new FormData();
    formdata.append(`driver_pdf`, pdf);
    formdata.append(`driver_id`, fieldValues.driver_id);
    axiosInstance
      .post(`pdf/${id}`, formdata)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          getBrokerpdfid(id);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const addComments = (id) => {
    if (fieldValues.comments === "") {
      toast.error("Comment field required");
    } else if (fieldValues.type === 0) {
      toast.error("Select Comment For");
    } else {
      setLoader(true);
      var formdata = new FormData();
      formdata.append(`pdf_id`, id);
      formdata.append(`comment`, fieldValues.comments);
      formdata.append(`type`, fieldValues.type);
      axiosInstance
        .post(`comment`, formdata)
        .then((response) => {
          if (response.data.status) {
            getBrokerpdfid(id);
            setFieldValues((prevValues) => ({
              ...prevValues,
              comments: "",
              type: 0,
            }));

            toast.success(response.data.message);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
    }
  };
  useEffect(() => {
    getBrokerPdf();
  }, []);
  console.log(fieldValues, "borrower_pdf");
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">PDF</h4>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between">
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
              {""}
            </span>
            <span className="table-index">
              Go to page :{" "}
              <input
                type="number"
                className="ml-2"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  gotoPage(pageNumber);
                }}
              />
            </span>
          </div>
          <div className="text-center">
            <div className="filter-pagination  mt-3">
              <button
                className=" previous-button"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>

              <button
                className="previous-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <button
                className="next-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
              <button
                className=" next-button"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Update Modal Start */}
      <Modal show={editshow} onHide={onEditHide} size="xl">
        <Modal.Header closeButton>PDF</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h3>Driver's Pdf :</h3>
                {pdfBlobURL || brokerpdf?.driver_pdf ? (
                  <div className="position-relative">
                    <iframe
                      src={pdfBlobURL ? pdfBlobURL : brokerpdf?.driver_pdf}
                      title="PDF Preview"
                      width="100%"
                      height="500px"
                    />
                    {pdfBlobURL === null ? null : brokerpdf?.driver_pdf ===
                      "" ? null : (
                      <div className="position-absolute top-0 end-0">
                        <div
                          className="c-pointer p-3 fs-3 text-danger"
                          // style={{ color: "#ff6746 !important" }}
                          onClick={() => {
                            setPdfBlobURL(null);
                            setPdf(null);
                          }}
                        >
                          &#x2715;
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center c-pointer"
                    style={{
                      height: 500,
                      border: "0.0625rem dashed #2e2e42",
                    }}
                    onClick={viewPdf}
                  >
                    <h3 className="text-white">Click Here to Upload file</h3>
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <h3>Broker's Pdf:</h3>
                <iframe
                  src={brokerpdf?.borrower_pdf}
                  frameBorder="3"
                  width="100%" // Set the width to 100% for full-width display
                  height="500px" // Set the height to your desired size, e.g., 500px
                  title="PDF Viewer"
                />
              </div>
              <div className={`mt-3 col-md-12`}>
                <h5 className="text-capitalize">Driver</h5>
                <select
                  name={"driver_id"}
                  className="form-control"
                  value={fieldValues.driver_id}
                  onChange={handleInputChange}
                  disabled={brokerpdf?.driver_pdf === "" ? false : true}
                >
                  {brokerpdf?.driver_pdf !== "" ? (
                    <option selected hidden disabled>
                      {brokerpdf?.driver?.name}
                    </option>
                  ) : (
                    <option selected hidden disabled value={0}>
                      Select Driver...
                    </option>
                  )}

                  {driverData.map((e) => (
                    <option value={e.id}>{e.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mt-2 ">
              <h5>Comments For:</h5>

              <div className="col-md-6 border p-3 mt-2">
                <h5 className="text-center">Broker</h5>
                <div className="d-flex flex-wrap">
                  {brokerpdf?.comments?.length > 0 ? (
                    brokerpdf?.comments
                      ?.filter((s) => s.type === "broker")
                      .map((e) => (
                        <p
                          className="p-3 text-white border border-3 border-light me-2"
                          style={{ width: "fit-content" }}
                          title={e.date}
                        >
                          {e.comment}
                        </p>
                      ))
                  ) : (
                    <p
                      className="p-3 text-white border border-3 border-light me-2"
                      style={{ width: "fit-content" }}
                    >
                      No Comment Found
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-6 border p-3 mt-2">
                <h5 className="text-center">Driver</h5>
                <div className="d-flex flex-wrap">
                  {brokerpdf?.comments?.length > 0 ? (
                    brokerpdf?.comments
                      ?.filter((s) => s.type === "driver")
                      .map((e) => (
                        <p
                          className="p-3 text-white border border-3 border-light me-2"
                          style={{ width: "fit-content" }}
                          title={e.date}
                        >
                          {e.comment}
                        </p>
                      ))
                  ) : (
                    <p
                      className="p-3 text-white border border-3 border-light me-2"
                      style={{ width: "fit-content" }}
                    >
                      No Comment Found
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="row my-3">
                  <div className="col-md-8">
                    <textarea
                      type="text"
                      className="input commenttextarea mt-2"
                      placeholder="Write a comment"
                      name="comments"
                      value={fieldValues.comments}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <select
                      name="type"
                      id=""
                      className="form-control mt-2 border-bottom"
                      onChange={handleInputChange}
                      value={fieldValues.type}
                    >
                      <option selected hidden value={0}>
                        Select Comment For
                      </option>
                      <option value="driver">Driver</option>
                      <option value="broker">Broker</option>
                    </select>
                  </div>
                </div>
                <button
                  className="primaryContained float-end"
                  type="submit"
                  onClick={() => addComments(brokerpdf.id)}
                >
                  Add Comment
                </button>
              </div>
            </div>
          </div>

          {/* <SpeechRecognitionDemo /> */}
        </Modal.Body>
        {brokerpdf?.driver_pdf === "" && (
          <Modal.Footer>
            <Button variant="primary" onClick={addDriverpdf}>
              Submit
            </Button>
            <Button variant="danger" onClick={onEditHide}>
              Close
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      <input
        type={"file"}
        accept=".pdf"
        ref={ref}
        className="d-none"
        onChange={handleFileChange}
      />
    </>
  );
};
export default BrokerPDF;
